import { useContext } from "react";
import { useController } from "react-hook-form";
import { FormContext } from "components/shared/Form";
import { StyledTextField } from "components/ui/atoms/SelectAutocomplete";
import { InputAdornment, IconButton } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const regex = new RegExp(/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi);

const isUrl = (value) => {
  if (!value.match(regex)) {
    return false;
  }

  return true;
};

const toHref = (value) =>
  /^https?:\/\//i.test(value) ? value : `https://${value}`;

export const RHFTextField = ({
  name,
  type,
  multiline,
  redirectButton,
  onChange: originalOnChange,
  onBlur: originalOnBlur,
  ...props
}) => {
  const {
    form: { control },
  } = useContext(FormContext);

  const {
    field: { onChange, onBlur, ...field },
    fieldState,
  } = useController({
    control: control,
    name: name,
  });

  if (field.value === null) {
    // this error is more explicit than the React one, debugging is much easier.
    console.error(
      `RHFTextField received a null value for field named '${name}'. It should be "" `,
    );
  }

  const shouldDisplayRedirectButton = field.value !== null && redirectButton && isUrl(field.value);


  return (
    <StyledTextField
      onChange={(v) => {
        onChange(v);
        originalOnChange && originalOnChange(v);
      }}
      onBlur={(v) => {
        onBlur(v);
        originalOnBlur && originalOnBlur(v);
      }}
      {...field}
      {...props}
      name={name}
      type={type}
      multiline={multiline}
      onWheel={(event) => {
        if (type == "number") {
          event.target.blur();
        }
      }}
      variant={multiline ? "filled" : "standard"}
      helperText={fieldState.error?.message}
      error={fieldState.invalid}
      slotProps={{
        input: {
          endAdornment: shouldDisplayRedirectButton ? (
            <InputAdornment position="end">
              <IconButton
                size="small"
                component="a"
                href={toHref(field.value)}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Ouvrir le lien"
              >
                <OpenInNewIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        },
      }}
    />
  );
};

export default RHFTextField;
